import { render } from "./PopupAgreement.vue?vue&type=template&id=5b03c902&scoped=true"
import script from "./PopupAgreement.vue?vue&type=script&lang=js"
export * from "./PopupAgreement.vue?vue&type=script&lang=js"

import "./PopupAgreement.vue?vue&type=style&index=0&id=5b03c902&scoped=true&lang=css"

import exportComponent from "D:\\Project\\Carryglobal\\GlobalLinkVIPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b03c902"]])

export default __exports__